<template>
  <div class="text-no-wrap" :class="currencyFontStyles">
    <span class="e2e-product-price">{{
      redeemable ? (isFree ? "Free" : points + " points") : price
    }}</span>
    <span v-if="byweight && !isFree" :class="unitFontStyles">/lb</span>
    <span v-else-if="!isFree" :class="unitFontStyles">/each</span>
  </div>
</template>

<script>
import { formatCurrency } from "@/util.js";
export default {
  name: "UnitPriceDisplay",
  computed: {
    currencyFontStyles() {
      const styles = {
        generic: "primary-color font-size-lg font-weight-semibold",
        modifier: "primary-color font-size-sm font-weight-semibold",
        search: "primary-color font-weight-semibold",
        summary: "color-suva-grey font-size-sm",
      };

      return styles[this.type];
    },
    price() {
      return this.formatCurrency(
        // this.byweight ? this.unitPrice * 100 : this.unitPrice
        this.unitPrice
      );
    },
    unitFontStyles() {
      const styles = {
        generic: "color-black-magic font-size-md",
        modifier: "color-black-magic font-size-xxs font-weight-regular",
        search: "color-black-magic font-size-xs",
        summary: "font-size-sm",
      };
      return styles[this.type];
    },
    isFree() {
      return !this.points && this.redeemable;
    },
  },
  methods: { formatCurrency },
  props: {
    byweight: Boolean,
    type: String,
    unitPrice: Number,
    redeemable: Boolean,
    points: Number,
  },
};
</script>
